module.exports = __webpack_public_path__ + "static/media/skype.e99b220a.png";